module.exports = __webpack_public_path__ + "img/empty-nft.dbe40cd7.svg";